import { Intro } from '../common/intro';
import { renderPhraseString } from '../../util';
import Text from '@ingka/text';

export const InjectedCurrentPage = ({
  phraseStrings,
}: {
  phraseStrings?: { [key: string]: string };
}) => {
  return (
    <>
      <Intro
        title={renderPhraseString('page-intro-title', phraseStrings)}
        description={renderPhraseString(
          'page-intro-description',
          phraseStrings,
        )}
      />
      <div className='p-4 w-full border-2 rounded border-dashed min-h-48 flex items-center justify-center'>
        <Text tagName='p' textStyle='Heading.S'>
          Iframe will be injected here
        </Text>
      </div>
    </>
  );
};
